import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { ClearAllFiltersButton } from '@/core/ClearAllFiltersButton';

interface SearchResultsProps {
  isLoading: boolean;
  onClear: () => void;
  searchString: React.ReactNode;
  extraClassNames?: string;
}

export const SearchResults = ({ isLoading, onClear, searchString, extraClassNames }: SearchResultsProps) => {
  const { t } = useTranslation();

  return (
    <div
      {...stylex.props(styles.results)}
      className={clsx('flexRowContainer', stylex.props(styles.results).className, extraClassNames)}>
      <h4>{t('SEARCH_DATA.SEARCH_RESULTS')}</h4>
      {!isLoading && (
        <div
          {...stylex.props(styles.activeFilters)}
          className={clsx('specActiveFilters', stylex.props(styles.activeFilters).className)}>
          {searchString}
          <ClearAllFiltersButton onClear={onClear} />
        </div>
      )}
    </div>
  );
};

const styles = stylex.create({
  results: { width: '100%', display: 'flex', flexDirection: 'column' },
  activeFilters: { marginBottom: 10, fontStyle: 'italic' },
});
